import { render, staticRenderFns } from "./ViewAndPay.vue?vue&type=template&id=68b43231&scoped=true"
import script from "./ViewAndPay.vue?vue&type=script&lang=js"
export * from "./ViewAndPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b43231",
  null
  
)

export default component.exports